import React from "react";
import { Context, Day } from "../types";
import { ContextButton } from "./ContextButton";

interface ContextsSectionProps {
  contexts: Context[];
  days: Day[];
  selectedDay: string;
  pressStartTime: number | null;
  pressScale: number;
  pressedItemId: number | null;
  onContextClick: (context: Context) => void;
  onPressStart: (context: Context, event: React.MouseEvent | React.TouchEvent) => void;
  onPressMove: (event: React.MouseEvent | React.TouchEvent) => void;
  onPressEnd: (context: Context) => void;
  onPressCancel: () => void;
}

export const ContextsSection: React.FC<ContextsSectionProps> = ({
  contexts,
  days,
  selectedDay,
  pressStartTime,
  pressScale,
  pressedItemId,
  onContextClick,
  onPressStart,
  onPressMove,
  onPressEnd,
  onPressCancel,
}) => {
  return (
    <div style={{ marginTop: "20px" }}>
      <h3 style={{
        margin: "0 0 12px 0",
        fontSize: "1.1em",
        color: "#212529"
      }}>
        Today's Context
      </h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {contexts.map((context) => (
          <ContextButton
            key={context.id}
            context={context}
            days={days}
            selectedDay={selectedDay}
            pressStartTime={pressStartTime}
            pressScale={pressScale}
            pressedItemId={pressedItemId}
            onPressStart={onPressStart}
            onPressMove={onPressMove}
            onPressEnd={onPressEnd}
            onPressCancel={onPressCancel}
            onClick={onContextClick}
          />
        ))}
      </div>
    </div>
  );
};